// extracted by mini-css-extract-plugin
export default {"card":"button_card__WAUvF","card--white":"button_card--white__x-N6M"};